module.exports = __webpack_public_path__ + "static/media/wood_plus.06fab0c1.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/wood_plus.jpeg
// module id = 304
// module chunks = 0